(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/pool-betting/aria-utils/assets/javascripts/get-outcome-arialabel-score.js') >= 0) return;  svs.modules.push('/components/pool-betting/aria-utils/assets/javascripts/get-outcome-arialabel-score.js');
"use strict";


const getOutcomeAriaLabelScore = _ref => {
  let svenskaFolketValue = _ref.svenskaFolketValue,
    postfixSymbol = _ref.postfixSymbol,
    participantName = _ref.participantName,
    sign = _ref.sign;
  const ariaLabelScore = "".concat(sign, " m\xE5l av ").concat(participantName);
  const ariaLabel = svenskaFolketValue ? "".concat(ariaLabelScore, ", Svenska folket ").concat(svenskaFolketValue) : ariaLabelScore;
  return postfixSymbol ? "".concat(ariaLabel).concat(postfixSymbol) : ariaLabel;
};
setGlobal('svs.components.poolBetting.ariaUtils.getOutcomeAriaLabelScore', getOutcomeAriaLabelScore);

 })(window);